import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "for-mac-and-linuxwith-sail-and-docker"
    }}>{`For MAC and Linux(with sail and docker)`}</h2>
    <p>{`There is an alternate installation procedure for linux and mac. You can follow below procedure to getting started with `}<inlineCode parentName="p">{`sail`}</inlineCode></p>
    <h4 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h4>
    <ul>
      <li parentName="ul">{`Docker`}
        <blockquote parentName="li">
          <p parentName="blockquote">{`NB: Move pickbazar-laravel folder from Pickbazar Laravel - React Next Rest & GraphQL Ecommerce With Multivendor folder`}</p>
        </blockquote>
      </li>
    </ul>
    <h4 {...{
      "id": "installation-video"
    }}>{`Installation Video`}</h4>
    <h4 {...{
      "id": "rest-api"
    }}>{`REST API`}</h4>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/xkkGC448d1g" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <blockquote>
      <p parentName="blockquote">{`Follow this tutorial for install REST API`}</p>
    </blockquote>
    <h4 {...{
      "id": "graphql-api"
    }}>{`GraphQL API`}</h4>
    <iframe width="1024" height="600" src="https://www.youtube.com/embed/arwEWD4CCxA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <blockquote>
      <p parentName="blockquote">{`Follow this tutorial for install GraphQL`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Run Docker application first`}</li>
      <li parentName="ul">{`Now go to your pickbazar-laravel root directory and run `}<inlineCode parentName="li">{`bash install.sh`}</inlineCode>{`. It will guide you through some process. Follow those steps carefully and your app will be up and running`}</li>
      <li parentName="ul">{`Navigate to `}<inlineCode parentName="li">{`api`}</inlineCode>{` then `}<inlineCode parentName="li">{`sail down`}</inlineCode>{` to stop the container. If you want to remove the volumes then `}<inlineCode parentName="li">{`sail down -v`}</inlineCode></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`NB: your frontend `}<inlineCode parentName="p">{`NEXT_PUBLIC_GRAPHQL_API_ENDPOINT`}</inlineCode>{` env value will be `}<inlineCode parentName="p">{`localhost/graphql`}</inlineCode></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`NB: your frontend `}<inlineCode parentName="p">{`NEXT_PUBLIC_REST_API_ENDPOINT`}</inlineCode>{` env value will be `}<inlineCode parentName="p">{`localhost/`}</inlineCode></p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`For details api doc and requirements details you can go to `}<a parentName="p" {...{
          "href": "/laravel-api"
        }}>{`Laravel API`}</a></p>
    </blockquote>
    <h2 {...{
      "id": "getting-started-with-frontend"
    }}>{`Getting Started with Frontend`}</h2>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`After configuring API & running it successfully you can choose the directory where you need to work`}</li>
    </ol>
    <h4 {...{
      "id": "note-only-for-windows-user--if-you-want-to-use-graphql-version"
    }}>{`NOTE: only for windows user ( if you want to use GraphQL version)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`- Go to your specific project root and find \`.graphql-let.yml\`.
- To find the file go to \`admin\` => \`graphql\` => \`.graphql-let-yml\`
- Replace the env variable \`\${NEXT_PUBLIC_GRAPHQL_API_ENDPOINT}\` in schema field manually
- Provide your API url in the schema field.

"schema: \${NEXT_PUBLIC_GRAPHQL_API_ENDPOINT}",
to
"schema: https://localhost:8000/graphql",

- Also change the dev command at \`package.json\`
- Go to \`shop/package.json\` file and change the scripts:

"codegen": "node -r dotenv/config $(yarn bin)/graphql-let",
to
"codegen": "graphql-let",
`}</code></pre>
    <p>{`Below are the directories where you will choose to work for frontend stuffs`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# For Admin GraphQL
cd admin/graphql
# For Admin REST
cd admin/rest
# For Shop GraphQL or REST
cd shop
`}</code></pre>
    <p>{`After choosing your working directory
`}<strong parentName="p">{`Go to specific folder and rename the `}<inlineCode parentName="strong">{`.env.template`}</inlineCode>{` => `}<inlineCode parentName="strong">{`.env`}</inlineCode>{` and put your api endpoint here. You will find `}<inlineCode parentName="strong">{`.env.template`}</inlineCode>{` file at the root of your `}<inlineCode parentName="strong">{`admin/{chosen-directory-name}`}</inlineCode>{` or `}<inlineCode parentName="strong">{`shop`}</inlineCode></strong></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`Run yarn at the root directory.`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# on pickbazar/root directory
yarn
`}</code></pre>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">
        <h3 parentName="li" {...{
          "id": "scripts-to-run-the-fronted-app"
        }}>{`Scripts To Run the fronted App`}</h3>
      </li>
    </ol>
    <h4 {...{
      "id": "for-admin-"
    }}>{`For Admin :`}</h4>
    <p>{`For starting the admin dashboard part with corresponding api data run below commands.`}</p>
    <ul>
      <li parentName="ul">{`using workspace (At the root of the pickbazar directory, you can run the below commands)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev:admin-gql

# REST
yarn dev:admin-rest
`}</code></pre>
    <p><img alt="frontend script" src={require("../../images/frontend-script.png")} /></p>
    <ul>
      <li parentName="ul">{`without workspace(if you want to run the command within specific project root of `}<inlineCode parentName="li">{`admin/{chosen-directory-name}`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev

# REST
yarn dev
`}</code></pre>
    <p>{`This command will run the app in development mode. Open the suggested url in your terminal. like => http://localhost:3000 .`}</p>
    <p><strong parentName="p">{` Note: `}</strong></p>
    <ul>
      <li parentName="ul">{`The page will automatically reload if you make changes to the code. You will see the build errors and lint warnings in the console.`}</li>
      <li parentName="ul">{`If you saw any error while running make Sure you setup your API endpoint properly at `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file.`}</li>
    </ul>
    <h4 {...{
      "id": "for-shop-"
    }}>{`For Shop :`}</h4>
    <h4 {...{
      "id": "shop-config"
    }}>{`Shop config`}</h4>
    <p>{`From `}<inlineCode parentName="p">{`v4.0.0`}</inlineCode>{`, we changed the structure of the `}<inlineCode parentName="p">{`shop`}</inlineCode>{` directory. So if you're using `}<inlineCode parentName="p">{`v4.0.0`}</inlineCode>{` or later, then you've to do a little bit of customization of the `}<inlineCode parentName="p">{`shop`}</inlineCode>{` directory.`}</p>
    <p>{`At first open `}<inlineCode parentName="p">{`pickbazar -> shop`}</inlineCode>{`,`}</p>
    <ul>
      <li parentName="ul">{`For `}<inlineCode parentName="li">{`REST`}</inlineCode>{`, copy `}<inlineCode parentName="li">{`tsconfig.rest.json`}</inlineCode>{` content to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode>{`
or`}</li>
      <li parentName="ul">{`For `}<inlineCode parentName="li">{`GraphQL`}</inlineCode>{` copy `}<inlineCode parentName="li">{`tsconfig.graphql.json`}</inlineCode>{` content to `}<inlineCode parentName="li">{`tsconfig.json`}</inlineCode></li>
    </ul>
    <p>{`Then open `}<inlineCode parentName="p">{`pickbazar -> shop -> .env`}</inlineCode>{` and change `}<inlineCode parentName="p">{`FRAMEWORK_PROVIDER`}</inlineCode>{` to `}<inlineCode parentName="p">{`rest`}</inlineCode>{` for REST installation or `}<inlineCode parentName="p">{`graphql`}</inlineCode>{` for Graphql Installation.`}</p>
    <p>{`Then to starting the shop part with corresponding api run below commands.`}</p>
    <ul>
      <li parentName="ul">{`using workspace (At the root of the pickbazar directory, you can run the below commands)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev:shop-gql

# REST
yarn dev:shop-rest
`}</code></pre>
    <p><img alt="shop script" src={require("../../images/shop-script.png")} /></p>
    <ul>
      <li parentName="ul">{`without workspace(if you want to run the command within specific project root of `}<inlineCode parentName="li">{`shop`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# for dev mode run below command
# GraphQL
yarn dev

# REST
yarn dev
`}</code></pre>
    <p><strong parentName="p">{` If you want to test your production build admin or shop in local environment then run the below commands. `}</strong></p>
    <h4 {...{
      "id": "admin-at-the-root-of-the-pickbazar-directory-you-can-run-the-below-commands"
    }}>{`Admin (At the root of the pickbazar directory, you can run the below commands)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# build admin for production
yarn build:admin-gql

#start admin in production mode
yarn start:admin-gql
`}</code></pre>
    <h4 {...{
      "id": "shop-at-the-root-of-the-pickbazar-directory-you-can-run-the-below-commands"
    }}>{`Shop (At the root of the pickbazar directory, you can run the below commands)`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# build shop for production
yarn build:shop-gql

# start shop in production mode
yarn start:shop-gql
`}</code></pre>
    <p><img alt="build1" src={require("../../images/build-1.png")} />{`
`}<img alt="build2" src={require("../../images/build-2.png")} />{`
`}<img alt="start" src={require("../../images/start.png")} /></p>
    <p><strong parentName="p">{` Note `}</strong>{`:
Please see `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file for other builtin helper commands.`}</p>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">{`For development purpose we use yarn workspace if you want to use it then see the `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file at root, for various workspace specific command.`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`if you prefer single template then just copy the required template folder and separate them. you'll find their `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file within them and follow the command for dev, build, start.`}</li>
    </ul>
    <ol {...{
      "start": 8
    }}>
      <li parentName="ol">{`For further development & customization check our `}<a parentName="li" {...{
          "href": "/customization"
        }}>{`Frontend Customization`}</a>{` guide.`}</li>
    </ol>
    <h2 {...{
      "id": "available-cli-command"
    }}>{`Available CLI command`}</h2>
    <p>{`We provide some CLI command for developer file easy. Please visit this `}<a parentName="p" {...{
        "href": "/api-command"
      }}>{`link`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      